module.exports = __webpack_public_path__ + "img/fnh2.73985c3a.jpg";